import { Progress } from 'antd';
import React from 'react';
import './index.less';
interface ICourseOverviewProps {
  courseName: string;
  topicName?: string;
  steps: any[];
  progress: number;
  currentStep: number;
}

const CourseOverview: React.FunctionComponent<ICourseOverviewProps> = ({
  courseName,
  topicName = '',
  steps,
  progress,
  currentStep,
}) => (
  <div className="course-left-overview">
    <div className="course-name">{courseName}</div>
    <div className="topic-name">{topicName}</div>
    <div className="course-progress-bar">
      <Progress
        format={(percent) => `${percent}%`}
        className="round-progress"
        strokeWidth={10}
        strokeColor="#EF6B28"
        trailColor="#C7C7C7"
        type="circle"
        width={75}
        percent={progress}
      />
    </div>
  </div>
);

export default CourseOverview;
